import React from 'react';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';

function SystemTransactionSettingsPageView({
  form,
  defaultFeePips,
  usingDefaultFeePips,
  isLoading,
  isSaving,
  error,
  success,
  formErrors,
  hasChanges,
  onFormChange,
  resetForm,
  saveForm,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts
        info={isSaving ? t('transactionSettings.savingInfo') : ''}
        error={error}
        success={success}
      />
      <PageHeader title={t('transactionSettings.title')} subtitle={t('transactionSettings.subtitle')} />

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <LoadingContainer isLoading={isLoading} hasData className="">
            <form onSubmit={saveForm}>
              <ul className="nav nav-tabs mb-4" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" type="button" role="tab" aria-selected="true">
                    {t('transactionSettings.internalTransferTab')}
                  </button>
                </li>
              </ul>

              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">{t('transactionSettings.feePipsLabel')}</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    className={`form-control ${formErrors.feePips ? 'is-invalid' : ''}`}
                    value={form.feePips}
                    onChange={(event) => onFormChange('feePips', event.target.value)}
                    disabled={isSaving}
                    required
                  />
                  {formErrors.feePips ? <div className="invalid-feedback">{formErrors.feePips}</div> : null}
                  <div className="form-text">
                    {t('transactionSettings.defaultFeePipsHelp', { defaultFeePips })}
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="border rounded p-3 bg-light h-100">
                    <div className="text-muted small mb-1">{t('transactionSettings.effectiveSourceLabel')}</div>
                    <div className="fw-semibold">
                      {usingDefaultFeePips
                        ? t('transactionSettings.usingDefaultFeePips', { defaultFeePips })
                        : t('transactionSettings.usingSavedFeePips')}
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={resetForm}
                  disabled={isSaving || !hasChanges}
                >
                  {t('transactionSettings.reset')}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading || isSaving || !hasChanges}
                >
                  {t('transactionSettings.saveChanges')}
                </button>
              </div>
            </form>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default SystemTransactionSettingsPageView;
